import generateCustomIcon from './utils/generateCustomIcon';

export default generateCustomIcon(
  () => (
    <path d="M18.414 11v2H5.828l2.293 2.293-1.414 1.414L2 12l4.707-4.707 1.414 1.414L5.828 11h12.586zm2 9V4h2v16h-2z" />
  ),
  { viewBox: '5 1 14 21' },
);
